import type { RouteRecordRaw } from 'vue-router'

import { generateWebviewRoutes } from '~/scopes/webviews/generateWebviewRoutes'

import redirectIfWebview from '../webviews/middleware/redirectIfWebview'

import { OUTLET } from './routes-names'

// We expose the outlet pages on both the standard URL space and the webview
// namespace via `generateWebviewRoutes`.
export default (): RouteRecordRaw[] => {
  const outletRoutes: RouteRecordRaw[] = [
    {
      path: 'outlet',
      name: OUTLET.HOME,
      component: () =>
        import('~/scopes/outlet/pages/OutletHome/OutletHome.vue'),
      meta: {
        layout: 'outlet',
        owners: ['bot-squad-acquisition-front'],
        middleware: [redirectIfWebview],
      },
    },
    {
      path: 'outlet/:slug',
      name: OUTLET.CATEGORY,
      component: () =>
        import('~/scopes/outlet/pages/OutletCategory/OutletCategory.vue'),
      meta: {
        layout: 'outlet',
        owners: ['bot-squad-acquisition-front'],
        middleware: [redirectIfWebview],
      },
    },
    {
      path: 'outlet/p/:id',
      name: OUTLET.DETAIL,
      component: () =>
        import('~/scopes/outlet/pages/OutletDetail/OutletDetail.vue'),
      meta: {
        layout: 'outlet',
        owners: ['bot-squad-acquisition-front'],
        middleware: [redirectIfWebview],
      },
    },
  ]

  const webviewOutletRoutes = generateWebviewRoutes(outletRoutes)

  // Force layout: false on all webview outlet routes
  const webviewOutletRoutesWithoutLayout: RouteRecordRaw[] =
    webviewOutletRoutes.map((parentRoute) => {
      if (parentRoute.children) {
        return {
          ...parentRoute,
          children: parentRoute.children.map((childRoute) => ({
            ...childRoute,
            meta: {
              ...(childRoute.meta || {}),
              layout: false,
            },
          })),
        }
      }
      return parentRoute
    })

  return [...outletRoutes, ...webviewOutletRoutesWithoutLayout]
}
